// Pardot documentation regarding pardot form handlers:
// https://help.salesforce.com/articleView?id=pardot_form_handlers_integrate_form_handler.htm&type=5

// Blogpost explaining how this type of pardot form won't accept CORS:
// http://blog.greggant.com/posts/2019/03/11/pardot-limitations-in-modern-javascript-enviroments.html

// Stack-overflow suggesting a work-around using jsonp:
// https://stackoverflow.com/questions/47047487/simulate-a-jsonp-response-with-javascript-urls

function usePardotForm(url: string) {
  function submit(
    data: { [key: string]: string },
    onSuccess: () => void,
    onError: () => void,
  ) {
    // Combine the pairs into a single string and replace all %-encoded spaces to
    // the '+' character; matches the behaviour of browser form submissions.
    const urlEncodedData = Object.keys(data)
      .map(key => `${key}=${encodeURIComponent(data[key])}`)
      .join('&')
      .replace(/%20/g, '+');

    // @ts-ignore
    window.pardotCallback = data => {
      if (String(data).toUpperCase() === 'SUCCESS') {
        return onSuccess();
      }

      return onError();
    };

    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.src = `${url}?${urlEncodedData}&callback=pardotCallback`;
    script.onerror = onError;
    document.body.appendChild(script);
  }

  return submit;
}

export default usePardotForm;
